import { AllStatusesTypes } from 'interfaces';

type RecognitionByStatusParams = {
  status: AllStatusesTypes;
  isOwner: boolean;
};

export const recognitionKeys = {
  all: ['recognitions'] as const,
  recognition: (id: string) => [...recognitionKeys.all, id] as const,
  recognitionByStatus: (params: RecognitionByStatusParams) =>
    [...recognitionKeys.all, params] as const,
};
